import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { UNARY_OPERATORS } from 'dashboard/apps/DashboardLayoutEditor/CaseConditionalLogicEditor/constants';
import FieldOrValueInput from 'dashboard/apps/DashboardLayoutEditor/CaseConditionalLogicEditor/FieldOrValueInput';
import ReactSelect from 'dashboard/components/ReactSelect';
import { ConditionalRuleValueTypes, RuleValueTypes } from 'dashboard/lib/workflows';
import { WorkflowOperatorKey } from 'dashboard/models/workflow';
import { JsonSchema } from 'lib/json-schema';
import { isMultiValue } from 'lib/workflows';

const FIELD_VALUE_OPTIONS = [
  {
    value: RuleValueTypes.Field,
    label: 'Field',
  },
  {
    value: RuleValueTypes.Value,
    label: 'Value',
  },
];

const FieldValueBlockWrapper = styled('div')<{
  enableFieldValueDropdown: boolean;
}>`
  display: grid;

  ${({ enableFieldValueDropdown }) => enableFieldValueDropdown && `grid-template-columns: 1fr 2fr;`}
  grid-column-gap: ${Spacing[1]};
`;

const FieldValueBlockChild = styled.div`
  position: relative;

  &:focus-within {
    z-index: 1;
  }
`;

interface FieldValueBlockProps {
  enableFieldValueDropdown: boolean;
  dropdownType: ConditionalRuleValueTypes;
  hasOperatorOptions: boolean;
  editable: boolean;
  operator: WorkflowOperatorKey;
  jsonSchema: JsonSchema;
  fieldSchema: JsonSchema | null;
  formattedRightValue: string | string[];
  valid: boolean;
  setDropdownType: (val: ConditionalRuleValueTypes) => void;
  updateRuleWithRightValue: (value: string) => void;
}

const FieldValueBlock = ({
  enableFieldValueDropdown,
  dropdownType,
  hasOperatorOptions,
  editable,
  operator,
  jsonSchema,
  fieldSchema,
  formattedRightValue,
  valid,
  setDropdownType,
  updateRuleWithRightValue,
}: FieldValueBlockProps) => {
  const updateFieldValueDropdown = (val: ConditionalRuleValueTypes) => {
    if (val !== dropdownType) {
      setDropdownType(val);
      updateRuleWithRightValue('');
    }
  };

  const isDisabled =
    !hasOperatorOptions || !editable || !operator || UNARY_OPERATORS.includes(operator);

  const hasError = !valid && hasOperatorOptions && editable && !!operator;

  return (
    <FieldValueBlockWrapper enableFieldValueDropdown={enableFieldValueDropdown}>
      {enableFieldValueDropdown && (
        <FieldValueBlockChild>
          <ReactSelect<RuleValueTypes>
            id='edit-rule-input-possibilities__field-or-value'
            value={dropdownType}
            options={FIELD_VALUE_OPTIONS}
            disabled={isDisabled}
            onChange={updateFieldValueDropdown}
            portal
          />
        </FieldValueBlockChild>
      )}
      <FieldValueBlockChild>
        {fieldSchema && (
          <FieldOrValueInput
            configType={dropdownType}
            jsonSchema={jsonSchema}
            fieldSchema={fieldSchema}
            formattedValue={formattedRightValue}
            disabled={isDisabled}
            onChange={(val) => updateRuleWithRightValue(val)}
            isMulti={isMultiValue(operator)}
            hasError={hasError}
          />
        )}
      </FieldValueBlockChild>
    </FieldValueBlockWrapper>
  );
};

export default FieldValueBlock;
